<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>{{ titulo }}</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-5 p-md-5">
                        <label>Descrição <span class="campo-obrigatorio">*</span> </label>
                        <InputText type="text" v-model.trim="descricaoConfiguracao" maxlength="80"/>
                    </div> 
                    <div class="p-field p-col-5 p-md-5">                             
                        
                        <label for="descricao">Tipo de escala</label>
                        <!-- <SelectButton v-model="tipoEscala" :options="opcoes" optionLabel="nome" optionValue="valor" @blur="reconfigurarEscalaNaEdicao"/> -->
                       <span class="p-buttonset">
                            <Button label="Quadro de Horários" :class="tipoEscala == 'EQH' ? '' : 'p-button-outlined p-button-secondary'" @click="reconfigurarEscalaNaEdicao('EQH')"/>
                            <Button label="Revezamento" :class="tipoEscala == 'ERC' ? '' : 'p-button-outlined p-button-secondary'" @click="reconfigurarEscalaNaEdicao('ERC')" v-if="permissaoRevezamento"/>
                        </span>
             
                    </div>                   
                </div>
                <TabView class="p-mb-3">
                    <TabPanel header="Quadro de Horários" v-if="tipoEscala === 'EQH'" class="p-mt-3">
                        <QuadroHorarios ref="quadroHorario"/>
                    </TabPanel>
                    <TabPanel header="Revezamento" class="p-mt-3" v-else>
                        <Revezamento ref="revezamento"/>
                    </TabPanel>
                    <TabPanel header="Contratual" class="p-mt-3">
                        <PoliticaContratual ref="politicaContratual"/>
                    </TabPanel>
                    <TabPanel header="DSR" class="p-mt-3">
                        <PoliticaDSR ref="politicaDSR"/>
                    </TabPanel>
                    <TabPanel header="Atrasos" class="p-mt-3">
                        <PoliticaAtrasos ref="politicaAtrasos"/>
                    </TabPanel>
                    <TabPanel header="Horas Extras" class="p-mt-3">
                        <PoliticaHorasExtras ref="politicaHoraExtra"/>
                    </TabPanel>
                    <TabPanel header="Banco de Horas" class="p-mt-3" v-if="!esconderBancoHoras && permissaoBancoHoras">
                        <PoliticaBancoHoras ref="politicaBancoHora"/>
                    </TabPanel>
                </TabView>

                <Button label="Cancelar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>
                <Button label="Salvar" class="p-button-primary p-ml-2" icon="pi pi-check" @click="salvar"/>

                <label class="p-ml-3 campo-obrigatorio"><span>*</span> Campos obrigatórios</label>
			</div>
		</div>
	</div>
</template>

<script>
import PoliticaAtrasos from '@/components/pages/cadastro/escalas/PoliticaAtrasos';
import PoliticaBancoHoras from '@/components/pages/cadastro/escalas/PoliticaBancoHoras';
import PoliticaContratual from '@/components/pages/cadastro/escalas/PoliticaContratual';
import PoliticaDSR from '@/components/pages/cadastro/escalas/PoliticaDSR';
import PoliticaHorasExtras from '@/components/pages/cadastro/escalas/PoliticaHorasExtras';
import QuadroHorarios from '@/components/pages/cadastro/escalas/QuadroHorarios';
import Revezamento from '@/components/pages/cadastro/escalas/Revezamento';
import ConfiguracaoEscalaService from '@/service/ConfiguracaoEscalaService';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {   
    configuracaoEscalaService: null,
    props: ['id'],
    data() {        
        return {            
            titulo: 'Nova Escala de Horários',
            descricaoConfiguracao: '',
            tipoEscala: 'EQH',
            opcoes: [{nome: 'Quadro de Horários', valor: 'EQH'}, {nome: 'Revezamento', valor: 'ERC'}],   
            esconderBancoHoras: false,     
            configuracaoEscalaHorario: null,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes']),       
        salvar() {
            if(this.descricaoConfiguracao == '') {
               exibirMensagemSis(this, 'Informe a descrição da configuração', true);
            } else {
                try {
                    let escalaHorario = null;                
                    if(this.tipoEscala == 'EQH') {// EQH = Escala Quadro de Horários - ERC Escala Revezamento e Ciclo.
                        // Quando de horários
                        escalaHorario = this.$refs.quadroHorario.getConfiguracao();
                        escalaHorario.quadroHorario.descricao = this.descricaoConfiguracao+'_EQH';
                    } 
                    else { // Revezamento é um tipo QuadroHorario mas com uma configuração diferente.
                        // Revezamento
                        escalaHorario = this.$refs.revezamento.getConfiguracao();
                        escalaHorario.quadroHorario.descricao = this.descricaoConfiguracao+'_ERC';
                    }     
                    // Politica contratual
                    let configPContratual = this.$refs.politicaContratual.getConfiguracao();
                    configPContratual.descricao = this.descricaoConfiguracao+'_PC';
                    configPContratual.parametroRefeicao = escalaHorario.parametroRefeicao;
                    configPContratual.descontarSegundoIntervalo = escalaHorario.descontarSegundoIntervalo;
                    // Politica DSR
                    let configPDSR = this.$refs.politicaDSR.getConfiguracao();
                    configPDSR.descricao = this.descricaoConfiguracao+'_PDSR';
                    // Politica de atrasos
                    let configPAtrasos = this.$refs.politicaAtrasos.getConfiguracao();
                    configPAtrasos.descricao = this.descricaoConfiguracao+'_PAtr';
                    // Politica de hroas extras
                    let configPHE = this.$refs.politicaHoraExtra.getConfiguracao();
                    configPHE.politicaHoraExtra.descricao = this.descricaoConfiguracao+'_PHE';                         
                    let requisicao = {
                        configuracao: {
                            descricao: this.descricaoConfiguracao,
                            tipoEscala: this.tipoEscala,
                            incluirBancoHoras: false,
                            quadroHorario: escalaHorario.quadroHorario,
                            diasDaSemana: escalaHorario.diasDaSemana,
                            diasDaSemanaExcluir: escalaHorario.diasDaSemanaExcluir,
                            politicaContratual: configPContratual,
                            politicaDSR: configPDSR,
                            politicaAtraso: configPAtrasos,
                            politicaHoraExtra: configPHE.politicaHoraExtra,
                            faixasHorasExtra: configPHE.faixas,
                            faixasHorasExtraExcluir: configPHE.faixasExcluidas,
                            politicaBancoHora: null,
                            bancoHoraArmazenamento: null,
                            bancoHoraTransferencia: null,
                        },
                        usuarioRequisicao: {...this.getDadosRequisicao()}
                    }; 
                    if(typeof this.$refs.politicaBancoHora !== 'undefined') {
                        // Politica de banco de horas
                        let configPBH = this.$refs.politicaBancoHora.getConfiguracao();                       
                        // Observe que a prioridadeHoraExtra foi selecionada na aba banco de horas.
                        // Se o usuário não selecionar incluir o banco, o valor default será prioridadeHoraExtra = 2.
                        // A prioridadeHoraExtra é um campo da Politica de horas extras.
                        if(configPBH.incluirBancoHoras) {
                            requisicao.configuracao.incluirBancoHoras = true;
                            configPBH.politicaBancoHora.descricao = this.descricaoConfiguracao+'_PBH';
                            // Prioridade selecionada na aba banco de hroas.
                            requisicao.configuracao.politicaHoraExtra['prioridadeHoraExtra'] = configPBH.prioridadeHoraExtra;
                            requisicao.configuracao.politicaBancoHora = configPBH.politicaBancoHora;
                            requisicao.configuracao.bancoHoraTransferencia = configPBH.bhTransferencia;
                            requisicao.configuracao.bancoHoraArmazenamento = configPBH.bhArmazenamento;
                        }
                    } 
                    if(this.configuracaoEscalaHorario == null) {
                        this.configuracaoEscalaService.salvar(requisicao)
                            .then(() => {                 
                                this.$router.push('/cadastros/escalas-horarios/?sc=t');
                            })
                            .catch(erro => {
                                exibirMensagem(this, erro);
                            });
                    } else {
                        // Id do contrato (formato antigo)
                        requisicao.configuracao['idContrato'] = this.configuracaoEscalaHorario.idContrato;                                         
                        this.configuracaoEscalaService.alterar(requisicao)
                            .then(() => {                 
                                this.$router.push('/cadastros/escalas-horarios/?sc=t');
                            })
                            .catch(erro => {
                                exibirMensagem(this, erro);
                            });
                    }                    
                } catch(erro) {                    
                    exibirMensagemSis(this, erro, true);
                } 
            }
                        
        },
        verificarContratoEdicao() {        
            if(this.id != null) {
                this.titulo = 'Editar Escala de Horários';               
                 let requisicao = {
                    idContrato: this.id,                   
					usuarioRequisicao: {...this.getDadosRequisicao()}
                 };               
                this.configuracaoEscalaService.buscar(requisicao)
					.then(resp => {        
                        this.descricaoConfiguracao = resp.data.descricao;
                        this.configuracaoEscalaHorario = resp.data;
                        this.configuracaoEscalaHorario['parametroRefeicao'] = resp.data.politicaContratual.parametroRefeicao;
                        this.configuracaoEscalaHorario['descontarSegundoIntervalo'] = resp.data.politicaContratual.descontarSegundoIntervalo;
                        let configuracao = resp.data;
                        // Não poderá incluir um banco de horas. A configuração já tem um histórico de dados.
                        if(configuracao.temHistorico && configuracao.politicaBancoHora == null) {
                            this.esconderBancoHoras = true;
                        } else if(configuracao.politicaBancoHora != null) {
                            this.$refs.politicaBancoHora.setConfiguracao(configuracao.politicaBancoHora, configuracao.bancoHoraArmazenamento, 
                                configuracao.bancoHoraTransferencia, configuracao.politicaHoraExtra.prioridadeHoraExtra);
                        }
                        this.tipoEscala = configuracao.tipoEscala;                        
                        // O tipo de escala poderá gerar erro, por exemplo, se o tipo selecionado for QH e 
                        // nesse momento this.tipoEscala = configuracao.tipoEscala; for um revezamento.
                        // O this.$refs.revezamento ainda será undefined.
                        // Esse método fará o teste até que o compenente seja montado/criado.
                        this.validarComponenteRender();                        
                        this.$refs.politicaContratual.setConfiguracao(configuracao.politicaContratual); 
                        this.$refs.politicaDSR.setConfiguracao(configuracao.politicaDSR); 
                        this.$refs.politicaAtrasos.setConfiguracao(configuracao.politicaAtrasos);
                        this.$refs.politicaHoraExtra.setConfiguracao(configuracao.politicaHoraExtra, configuracao.faixasHorasExtra); 
					})
					.catch(erro => {console.log(erro); exibirMensagem(this, erro)});
            }
        },
        reconfigurarEscalaNaEdicao(escala) {           
            this.tipoEscala = escala;
            this.validarComponenteRender();
        },
        cancelar() {
            this.$router.push('/cadastros/escalas-horarios/')
        },
        validarComponenteRender() {              
            if(this.configuracaoEscalaHorario != null) {
                let concluiu = false;
                if(this.tipoEscala == 'EQH') {
                    if(typeof this.$refs.quadroHorario !== 'undefined' && this.$refs.quadroHorario.carregado()) {
                        concluiu = true;
                        if(this.configuracaoEscalaHorario.tipoEscala == 'EQH') {
                            this.$refs.quadroHorario.setConfiguracao(this.configuracaoEscalaHorario);
                        }
                    }
                } else {// ERC
                    if(typeof this.$refs.revezamento !== 'undefined' && this.$refs.revezamento.carregado()) {
                        concluiu = true;
                        if(this.configuracaoEscalaHorario.tipoEscala == 'ERC') {   
                            this.$refs.revezamento.setConfiguracao(this.configuracaoEscalaHorario);                             
                        }                        
                    }                         
                }
                if(!concluiu) {
                    setTimeout(function(){this.validarComponenteRender()}.bind(this), 500);
                }
            }
        }, 
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
            this.permissaoBancoHoras = permissoes.includes(66);
            this.permissaoRevezamento = permissoes.includes(86);			
		}       
    },
    created() {
        this.validarPermissoes();
        this.configuracaoEscalaService = new ConfiguracaoEscalaService();
    },
    mounted() {
        this.verificarContratoEdicao();
    },
    components: {
        'PoliticaAtrasos': PoliticaAtrasos,
        'PoliticaBancoHoras': PoliticaBancoHoras,
        'PoliticaContratual': PoliticaContratual,
        'PoliticaDSR': PoliticaDSR,
        'PoliticaHorasExtras': PoliticaHorasExtras,
        'QuadroHorarios': QuadroHorarios,
        'Revezamento': Revezamento
    }
}
</script>

<style>

    .campo-obrigatorio {
        color: #E84630;
    }

</style>